/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_1_B1Inputs */

const en_mk_agent_1_b1 = /** @type {(inputs: Mk_Agent_1_B1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The work lands as an ordinary comment on the same issue`)
};

const id_mk_agent_1_b1 = /** @type {(inputs: Mk_Agent_1_B1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasil kerja masuk sebagai komentar biasa di issue yang sama`)
};

/**
* | output |
* | --- |
* | "The work lands as an ordinary comment on the same issue" |
*
* @param {Mk_Agent_1_B1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_1_b1 = /** @type {((inputs?: Mk_Agent_1_B1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_1_B1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_1_b1(inputs)
	return en_mk_agent_1_b1(inputs)
});